import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Subject} from '../../../node_modules/rxjs';
import {Router} from '@angular/router';
import {ReferenceTableService} from '../reference-table.service';
import {
  AgGridUtility,
  Announcement,
  CommonUtility,
  DataService,
  DateUtility,
  ServerConstantsService,
  SINGLE_ROW_HEADER,
  TimeUtility
} from '../shared';
import {NotificationsService} from 'angular2-notifications';
import 'jquery-ui/ui/widgets/draggable.js';
import {TaskChart} from "../shared/model/TaskChart";
import {ProviderDashboardSearch} from "../shared/model/ProviderDashboardSearch";
import {ReferralChart} from "../shared/model/ReferralChart";
import {ApptChart} from "../shared/model/ApptChart";
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LoaderComponent} from '../loader/loader.component';
import * as $ from 'jquery';

const OPEN = 'OP';
const IN_PROGRESS = 'IP';
const SCHEDULE = 'SH';
const RESCHEDULE = 'RS';

@Component({
  selector: 'app-provider-dashboard',
  templateUrl: './provider-dashboard.component.html',
  styleUrls: ['./provider-dashboard.component.scss']
})
export class ProviderDashboardComponent implements OnInit, AfterViewInit{
  @ViewChild('myReferral')
  canvas:ElementRef;

  sharedData: any;

  announcements : Announcement[] = [];
  announcementsList = null;
  maxValue: number;
  isAlreadyLoaded: boolean;
  countyCds: Array<any>;
  countyMap: Map<string, string>;
  private noData: boolean;
  dashboardSearchRequest : ProviderDashboardSearch;
  dashboardSearchResponse: ProviderDashboardSearch;

  taskStatusMap: any;
  taskTypeMap: any;
  prioritiesMap: any;
  prioritiesJson: any;
  appointmentTypeMap: any;
  ServerConstants: any;
  userActionNotificationsMap: any;

  private _danger = new Subject<string>();
  errorMessage: string;

  taskCounty: Array<any>;
  countiesSelect: Array<any>;
  appCounty: Array<any>;

  /************   Referral Chart *************/
  public doughnutChartLabels:string[] = [];
  public doughnutChartData:number[] = [];
  public doughnutChartType:string = 'doughnut';


  doughnutChartText : any = "0";
  gridApi: any;
  //Chart: any;

  //canvas : ElementRef;
  ctx: any ;

  countiesJson;

  public doughnutChartOptions = {
    elements: {
      center: {
        // the longest text that could appear in the center
        maxText: '100%',
        text: '90%',
        fontColor: '#36A2EB',
        fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        fontStyle: 'normal',
        // fontSize: 12,
        // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
        // if these are not specified either, we default to 1 and 256
        minFontSize: 1,
        maxFontSize: 256,
      }
    },
    responsive: true,
    legend: {
      position: 'bottom',
    },
    hover: {
      onHover: function(e) {
        var point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = 'pointer';
        else e.target.style.cursor = 'default';
      }
    },

    animation:{
      onComplete: () => {
        this.ctx = this.canvas.nativeElement.getContext("2d");
        var width = this.canvas.nativeElement.clientWidth,
          height = this.canvas.nativeElement.clientHeight;
        var fontSize = (height / 100).toFixed(2);
        this.ctx.font = "bold " +fontSize + "em Helvetica Neue";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = "black";
        var text = this.doughnutChartText,
          textX = Math.round((width - this.ctx.measureText(text).width) / 2),
          textY = height  / 2 - 25;
        this.ctx.fillText(text, textX, textY);
        this.ctx.restore();
      }}
  };

  public donutColors=[
    {
      backgroundColor: [
        'rgba(107,142,35,1)',
        'rgba(231,105,29,1)',
        'rgba(197,36,61,1.00)'
      ]
    }
  ];


  /********* Task Chart **********/
  noPendingTasks = 0;
  noOverdueTasks = 0;
  noUpcomingTasks = 0;

  taskChartDateTomorrow?: any;
  taskChartDateTomorrowPlus30?: any;
  taskChartDateYesterday?: any;
  numberTaskChartBefore: number;
  numberTaskChartDaysAfter: number;

  chartTaskOptions = {
    legend: {
      position: 'bottom',
    },
    responsive: true,
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Date'
        }
      }],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'No. of Tasks'
          },
          ticks: {
            beginAtZero: true,
            //scaleOverride : true,
            //suggestedMin: 10,
            max: this.maxValue,
            //suggestedMin: 10,
            stepSize: 2,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            },
          }
        }
      ]
    }
  };

  chartTaskData = [
    { data: [], label: 'Due Today' },
    { data: [], label: 'Upcoming' },
    { data: [], label: 'Overdue' }
  ];

  chartTaskLabels = [];

  public lineTaskChartColors:Array<any> = [
    { // orange
      backgroundColor: 'rgba(231,105,29,1)',
      borderColor: 'rgba(231,105,29,1)',
      pointBackgroundColor: 'rgba(231,105,29,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(231,105,29,1)'
    },
    { // blue
      backgroundColor: 'rgba(65,105,225,1)',
      borderColor: 'rgba(65,105,225,1)',
      pointBackgroundColor: 'rgba(65,105,225,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(65,105,225,1)'
    },
    { // red
      backgroundColor: 'rgba(197,36,61,1)',
      borderColor: 'rgba(197,36,61,1.00)',
      pointBackgroundColor: 'rgba(197,36,61,1.00)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(197,36,61,1.00)'
    }
  ];

  public lineAppChartColors:Array<any> = [
    { // blue
      backgroundColor: 'rgba(65,105,225,0.2)',
      borderColor: 'rgba(65,105,225,1)',
      pointBackgroundColor: 'rgba(65,105,225,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(65,105,225,1)'
    }
  ];

  /********* Appointment Chart *********/

  taskDueDates: any[];
  taskDueDatesMap: any;
  appTaskDueDate: number;
  numberAppointmentDays: number;

  numberAppointmentsToday: number;
  numberAppointmentsTomorrow: number;

  taskStatus: any[];
  priorities: any[];

  taskType: any[];
  appointmentType: any[];
  apptChartDateTomorrow?: any;
  apptChartDateTomorrowPlus5?: any;
  apptChartDateTodayPlus5?: any;
  apptChartDateFrom?: any;

  chartAppProvOptions = {
    legend: {
      position: 'bottom',
    },
    responsive: true,
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Date'
        }
      }],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'No. of Appointments'
          },
          ticks: {
            beginAtZero: true,
            scaleOverride : true,
            //suggestedMin: 10,
            max: this.maxValue,
            //suggestedMin: 10,
            stepSize: 2,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            },
          }
        }
      ]
    }
  };


  chartAppProvData = [ { data: [], label: 'No. of Appointments'} ];
  chartAppProvLabels = [];

  /*Grid Table*/
  columnDefs: any;
  context: any;
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;

  constructor(
    //private providerService: ProviderService,
    private http: HttpClient,
    private dataService: DataService,
    private router: Router,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private timeUtil: TimeUtility,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private dateUtil: DateUtility,
    private dateTimeUtil: TimeUtility,
    private agGridUtility: AgGridUtility,
    private modalService: NgbModal
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
  }

  ngAfterViewInit(){
    /*this.canvas = <HTMLCanvasElement> document.getElementById("myChart");
    this.ctx = this.canvas.getContext("2d");
    this.Chart.pluginService.register({
      afterUpdate: function (chart) {
        if (chart.config.options.elements.center) {
          var helpers = this.Chartx.helpers;
          var centerConfig = chart.config.options.elements.center;
          var globalConfig = this.Chart.defaults.global;
          var ctx = chart.chart.ctx;

          var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
          var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);

          if (centerConfig.fontSize)
            var fontSize = centerConfig.fontSize;
          // figure out the best font size, if one is not specified
          else {
            ctx.save();
            var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
            var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
            var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);

            do {
              ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
              var textWidth = ctx.measureText(maxText).width;

              // check if it fits, is within configured limits and that we are not simply toggling back and forth
              if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                fontSize += 1;
              else {
                // reverse last step
                fontSize -= 1;
                break;
              }
            } while (true)
            ctx.restore();
          }

          // save properties
          chart.center = {
            font: helpers.fontString(fontSize, fontStyle, fontFamily),
            fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
          };
        }
      },
      afterDraw: function (chart) {
        if (chart.center) {
          var centerConfig = chart.config.options.elements.center;
          var ctx = chart.chart.ctx;

          ctx.save();
          ctx.font = chart.center.font;
          ctx.fillStyle = chart.center.fillStyle;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
          var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
          ctx.fillText(centerConfig.text, centerX, centerY);
          ctx.restore();
        }
      },
    })*/
  }

  ngOnInit() {
    console.log("inside  dashboard/provider");
    this.sharedData = this.dataService.getSharedDataObject();
     /* Load Reference Tables*/
    this.data.currentMessage.subscribe(
      (message) => {

        this.parseRefTableData();
      });


      this.http.get<any>(this.ServerConstants.SERVER_API_URL + '/userinfo').subscribe(
        data => {
          var isProviderRole = false;
          for (const key in data) {
            if (data.hasOwnProperty(key)) {              
              console.log('role id: ' + data.roles[0].id);
              if(data.roles[0].id == 5){
                isProviderRole=true;
                break;
              }
            }
          }

          if(isProviderRole) {
            console.log('Provider Role');
            this.dashboardSearchRequest = new ProviderDashboardSearch();
            this.dashboardSearchRequest.taskChart = new TaskChart();
            this.dashboardSearchRequest.referralChart = new ReferralChart();
            this.dashboardSearchRequest.apptChart = new ApptChart();
        
            this.dashboardSearchRequest.referralChart.refCounty = "-1";
            this.dashboardSearchRequest.apptChart.appCounty = "-1";
            this.dashboardSearchRequest.taskChart.taskCounty = "-1";
        
            this.dashboardSearchResponse = new ProviderDashboardSearch();
            this.dashboardSearchResponse.announcements = [];
        
            this.isAlreadyLoaded = false;
        
            this.countiesSelect = [];
        
        
            //this.dashboardSearchRequest.todayDateTime = new Date();
            this.setTasksChart();
            this.setAppointmentChart();
            this.setReferralChart();
            this.setAnnouncements();
            this.formatDates();
        
            var ctx = this.canvas.nativeElement.getContext("2d");
            let me = this;
            this.getColumnDefinitions();
          } else {
            console.log('Redirecting to worker dashboard');
            this.router.navigate(['dashboard']);
          }                                    
 
}, response => {
console.log('error', response);
if(response.status === 401){
this.router.navigate(['dashboard']);
}
}, () => {

});

  }

  formatDates(){
    this.dashboardSearchRequest.todayDate = new Date();
    this.dashboardSearchRequest.todayDate = this.dateUtil.convertObjectDateForServer(
      this.dashboardSearchRequest.todayDate);

    /*Appointment*/
    this.dashboardSearchRequest.apptChart.apptChartDateFrom = this.dateUtil.convertObjectDateForServer(
      this.dashboardSearchRequest.apptChart.apptChartDateFrom);
    this.dashboardSearchRequest.apptChart.apptChartDateTo = this.dateUtil.convertObjectDateForServer(
      this.dashboardSearchRequest.apptChart.apptChartDateTo);

    /*task*/
    this.dashboardSearchRequest.taskChart.todayDate = this.dateUtil.convertObjectDateForServer(
      this.dashboardSearchRequest.taskChart.todayDate);
    /*this.dashboardSearchRequest.taskChart.taskChartDateFrom = this.dateUtil.convertObjectDateForServer(
      this.dashboardSearchRequest.taskChart.taskChartDateFrom);*/
      this.dashboardSearchRequest.taskChart.taskChartDateFrom = "2000/08/01";
    this.dashboardSearchRequest.taskChart.taskChartDateTo = this.dateUtil.convertObjectDateForServer(
      this.dashboardSearchRequest.taskChart.taskChartDateTo);
    /*Referral*/

    this.dashboardSearchRequest.referralChart.referralChartDateTo = this.dateUtil.convertObjectDateForServer(
      this.dashboardSearchRequest.referralChart.referralChartDateTo);
    this.dashboardSearchRequest.referralChart.referralChartDateFrom = this.dateUtil.convertObjectDateForServer(
      this.dashboardSearchRequest.referralChart.referralChartDateFrom);


  }

  setTasksChart(){
    this.numberTaskChartBefore = 5;
    this.numberTaskChartDaysAfter = 5;
    this.dashboardSearchRequest.taskChart.todayDate = new Date();
    this.dashboardSearchRequest.taskChart.taskChartDateFrom = new Date();
    this.dashboardSearchRequest.taskChart.taskChartDateFrom.setDate(this.dashboardSearchRequest.taskChart.taskChartDateFrom.getDate()
      - this.numberTaskChartBefore);
      console.log(this.dashboardSearchRequest.taskChart.taskChartDateFrom.getDate()
      - this.numberTaskChartBefore);
    this.dashboardSearchRequest.taskChart.taskChartDateTo = new Date();
    this.dashboardSearchRequest.taskChart.taskChartDateTo.setDate(this.dashboardSearchRequest.taskChart.taskChartDateTo.getDate()
      + this.numberTaskChartDaysAfter);

    this.taskChartDateTomorrow = new Date();
    this.taskChartDateTomorrow.setDate ( this.taskChartDateTomorrow.getDate() + 1) ;

    this.taskChartDateTomorrowPlus30 = new Date();
    this.taskChartDateTomorrowPlus30.setDate ( this.taskChartDateTomorrowPlus30.getDate() + 30 );

    this.taskChartDateYesterday = new Date();
    this.taskChartDateYesterday.setDate(  this.taskChartDateYesterday.getDate() -1 );

  }


  setAppointmentChart() {
    this.numberAppointmentDays = 10;
    this.dashboardSearchRequest.apptChart.apptChartDateFrom = new Date();
    this.dashboardSearchRequest.apptChart.apptChartDateFrom.setDate(this.dashboardSearchRequest.apptChart.apptChartDateFrom.getDate());
    this.dashboardSearchRequest.apptChart.apptChartDateTo = new Date();
    this.dashboardSearchRequest.apptChart.apptChartDateTo.setDate(this.dashboardSearchRequest.apptChart.apptChartDateTo.getDate() + 10);
    this.apptChartDateTomorrow = new Date();
    this.apptChartDateTomorrow.setDate( this.apptChartDateTomorrow.getDate() +1 );

    this.apptChartDateTomorrowPlus5 = new Date();
    this.apptChartDateTomorrowPlus5.setDate( this.apptChartDateTomorrowPlus5.getDate() + 6 );
    this.apptChartDateTodayPlus5 = new Date();
    this.apptChartDateTodayPlus5.setDate(this.apptChartDateTodayPlus5.getDate() + 5  );
  }

  setReferralChart(){
    this.dashboardSearchRequest.referralChart.referralChartDateTo = new Date();
    this.dashboardSearchRequest.referralChart.referralChartDateFrom = new Date(
      this.dashboardSearchRequest.referralChart.referralChartDateTo.getFullYear(),
      this.dashboardSearchRequest.referralChart.referralChartDateTo.getMonth(),
      1
    );
    //this.dashboardSearchRequest.referralChart.referralChartDateFrom.setDate( this.dashboardSearchRequest.referralChart.referralChartDateTo.getDate() -7);
    //this.dashboardSearchRequest.referralChart.referralChartDateFrom.setDate (
  }


  setAnnouncements() {}


  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Title',
        field: 'title',
        cellStyle: {'white-space': 'normal'},
      },
      {
        headerName: 'Date',
        field: 'effectiveToDt',
        filter: "agDateColumnFilter",
        width: 90,
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        }
      },
      {
        headerName: 'Priority',
        field: "priorityCd",
        width: 80,
        refData: this.prioritiesJson,
        cellStyle: {'white-space': 'normal'},
        valueGetter: this.getPriorityType
      }
    ];
    this.context = {
      component: this,
    };
    this.searchProviderDashboard();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  getPriorityType(params){
    const that = params.context.component;
    let priorityType = that.convertCode(that.prioritiesMap, params.data.priorityCd);
    if( params.data.priorityCd == undefined){
      priorityType = "";
    }
    return priorityType;
  }


  searchProviderDashboard() {
    setTimeout(() => this.modalService.open(LoaderComponent, {
      centered: true,
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
      backdropClass: 'loaderBackdrop',
      windowClass: '2'
    }), 0);

    this.http.post<ProviderDashboardSearch> (this.ServerConstants.SERVER_API_URL + "/dashboard/appointmentChart", this.dashboardSearchRequest ).subscribe(
      (val) => {
        /*setTimeout(() => {
          $('ngb-modal-window.2:visible').remove();
          $('ngb-modal-backdrop:visible').remove();
        }, 0);*/
        if(val.hasOwnProperty('errorCode')){
          this.notificationService.error('Dashboard', this.userActionNotificationsMap.ERROR);
        }
        else {
          this.dashboardSearchResponse = val;
          if (!this.isAlreadyLoaded) {
            let countiesArray = this.dashboardSearchResponse.counties.split(',');
            for (let count = 0; count < countiesArray.length; count++) {
              this.countiesSelect.push({
                value: countiesArray[count],
                name: this.convertCode(this.countyMap, countiesArray[count] + '')
              });
            }
            this.countiesSelect.sort(this.commonUtil.sortObjectsByProperty('name'));
            this.countiesSelect.unshift({value: '-1', name: 'Pick an Option'});
            //console.log(this.countiesSelect);
            this.isAlreadyLoaded = true;
          }
          this.newAppointmentDataChart(this.dashboardSearchResponse.apptChart.apptCharYData, this.dashboardSearchResponse.apptChart.apptCharXData);
          this.loadAnnouncements();
          /*this.updateTaskDataChart(this.dashboardSearchResponse.taskChart.pendingTaskChartYData,
            this.dashboardSearchResponse.taskChart.upcomingTaskChartYData,
            this.dashboardSearchResponse.taskChart.overdueTaskChartYData,
            this.dashboardSearchResponse.taskChart.taskChartXData);

          this.dashboardSearchResponse.taskChart.todayDate = new Date();
          this.updateReferralDataChart(this.dashboardSearchResponse.referralChart.referralData);*/
        }
        this.loadTaskStatusChart();
      },
      response => {
        this.notificationService.error('Dashboard', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }

  loadTaskStatusChart() {
  
    this.http.post<ProviderDashboardSearch> (this.ServerConstants.SERVER_API_URL + "/dashboard/taskStats", this.dashboardSearchRequest ).subscribe((data)=>{
        this.dashboardSearchResponse = data;        
        this.updateTaskDataChart(this.dashboardSearchResponse.taskChart.pendingTaskChartYData.slice(Math.max(this.dashboardSearchResponse.taskChart.pendingTaskChartYData.length - 11, 1)),
        this.dashboardSearchResponse.taskChart.upcomingTaskChartYData.slice(Math.max(this.dashboardSearchResponse.taskChart.upcomingTaskChartYData.length - 11, 1)),
        this.dashboardSearchResponse.taskChart.overdueTaskChartYData.slice(Math.max(this.dashboardSearchResponse.taskChart.overdueTaskChartYData.length - 11, 1)),
        this.dashboardSearchResponse.taskChart.taskChartXData.slice(Math.max(this.dashboardSearchResponse.taskChart.taskChartXData.length - 11, 1)),this.dashboardSearchResponse.taskChart.overdueTaskChart);

        this.dashboardSearchResponse.taskChart.todayDate = new Date();
      },
      response => {
        this.notificationService.error('Dashboard', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
    this.loadReferralStatsChart();
  }

  loadReferralStatsChart () {
    this.http.post<ProviderDashboardSearch> (this.ServerConstants.SERVER_API_URL + "/dashboard/referralChart", this.dashboardSearchRequest ).subscribe((data)=>{
        this.dashboardSearchResponse = data;
        this.updateReferralDataChart(this.dashboardSearchResponse.referralChart.referralData);
        setTimeout(() => {
          $('ngb-modal-window.2:visible').remove();
          $('ngb-modal-backdrop:visible').remove();
        }, 0);
      },
      response => {
        this.notificationService.error('Dashboard', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }

  loadAnnouncements () {
    this.http.post<ProviderDashboardSearch> (this.ServerConstants.SERVER_API_URL + "/dashboard/announcements", this.dashboardSearchRequest ).subscribe((data)=>{
        //this.dashboardSearchResponse.announcements = data.announcements;
        this.announcementsList = data.announcements
      },
      response => {
        this.notificationService.error('Dashboard', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }

  convertCode(myMap, code){
    if(myMap != undefined){
      return myMap.get(code);
    }
  }

  parseRefTableData(){
      this.taskStatus = this.data.getValueFromSharedDataMap("TASKSTATUS");
      this.priorities = this.data.getValueFromSharedDataMap("PRIORITY");

      this.taskStatusMap = this.commonUtil.createMapFromList(this.taskStatus);
      this.prioritiesMap = this.commonUtil.createMapFromList(this.priorities);

      this.prioritiesJson = this.commonUtil.createNativeMapFromList(this.priorities);

      this.countyCds = this.data.getValueFromSharedDataMap('COUNTIES');
      this.countyMap = this.commonUtil.createMapFromList(this.countyCds);
      this.countyMap.set("-1", "All Counties");
      this.countiesJson = this.commonUtil.createNativeMapFromList(this.countyCds);

      this.taskType = this.data.getValueFromSharedDataMap('TASKTYPES');
      this.taskTypeMap = this.commonUtil.createMapFromList(this.taskType);

    this.appointmentType = this.data.getValueFromSharedDataMap('APPOINTMENTTYPE');
      this.appointmentTypeMap = this.commonUtil.createMapFromList(this.appointmentType);

      this.taskDueDates = this.data.getValueFromSharedDataMap("TASKDUEDATES");
      this.taskDueDatesMap = this.commonUtil.createMapFromList(this.taskDueDates);

      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));

  }

  getAppointmentTaskDueDate() {
    for (let taskDD of this.taskDueDates) {
      if (taskDD.value === 'AP') {
        this.appTaskDueDate = taskDD.name;
        break;
      }
    }

  }

  newAppointmentDataChart(dataArr , labels) {

    let maxValue = Math.max.apply(Math, dataArr);
    maxValue = Math.ceil((maxValue+1) / 10) * 10;
    //maxValue = maxValue < 10 ? 10 : maxValue;
    this.chartAppProvOptions.scales.yAxes[0].ticks.max = maxValue;
    this.chartAppProvOptions.scales.yAxes[0].ticks.stepSize = maxValue/5;
    this.chartAppProvData[0].data = (dataArr);
    this.chartAppProvLabels = labels;

    this.numberAppointmentsToday = dataArr[0];
    this.numberAppointmentsTomorrow = dataArr[1];
  }

  updateReferralDataChart( referral){

    this.doughnutChartLabels.length = 0;
    this.doughnutChartLabels.push(
      referral[0] + ' - Action Taken This Month',
      referral[1] + ' - Action Not Taken This Month',
      referral[2] + ' - Action Not Taken Prior to This Month'
    );
    this.doughnutChartText = referral.reduce((a, b) => a + b, 0);
    //.add referral[0] + referral[1] + referral[2];
    this.doughnutChartData = referral;
  }

  chartReferralHovered(e:any) {
    const chart = e.active[0]._chart;
    const point = chart.getElementAtEvent(e.event);
    if (point.length > 0){
      console.log("onHover");
      e.target.style.cursor = 'pointer';
    }
    else e.target.style.cursor = 'default';
  }


  public chartReferralClicked(e:any):void {if (e.active.length > 0) {
    const chart = e.active[0]._chart;
    const activePoints = chart.getElementAtEvent(e.event);
    let toDate;
    let todayDate = new Date();
    let fromDate;
    let taskType = "RF";
    let taskStatus;
    let completionDtSw = 'N';

    if ( activePoints.length > 0) {
      // get the internal index of slice in pie chart
      const clickedElementIndex = activePoints[0]._index;
      const label = chart.data.labels[clickedElementIndex];
      // get value by index
      const value = chart.data.datasets[0].data[clickedElementIndex];

      if(clickedElementIndex === 0){
        /*Action taken this month*/
        fromDate = this.dashboardSearchRequest.referralChart.referralChartDateFrom;
        toDate = this.dashboardSearchRequest.referralChart.referralChartDateTo;
        taskStatus = "CO";
        completionDtSw = 'Y';
      }
      else if(clickedElementIndex === 1){
        /*Action not Taken this month*/
        fromDate = this.dashboardSearchRequest.referralChart.referralChartDateFrom;
        toDate = this.dashboardSearchRequest.referralChart.referralChartDateTo;
        taskStatus = "OP,IP";
      }
      else if(clickedElementIndex === 2){
        /*Action not taken prior this month*/
        //fromDate =moment().subtract(30,'days').calendar();
        toDate = this.dashboardSearchRequest.referralChart.referralChartDateFrom;
        taskStatus = "OP,IP";
      }
      this.goToTaskSearch(fromDate, toDate, taskType, taskStatus, this.dashboardSearchRequest.referralChart.refCounty, completionDtSw);
    }
  }
  }


  onChartClick($event){

  }

  updateTaskDataChart(pending, upcoming, overdue , labels,count){
    let maxValueP = Math.max.apply(Math, pending);
    let maxValueU = Math.max.apply(Math, upcoming);
    let maxValueO = Math.max.apply(Math, overdue);

    let maxValue = Math.max( maxValueP, maxValueU, maxValueO  );
    maxValue = Math.ceil((maxValue+1) / 10) * 10;
    this.noPendingTasks = pending.reduce((a, b) => a + b, 0);
    this.noUpcomingTasks = upcoming.reduce((a, b) => a + b, 0);
    //this.noOverdueTasks = overdue.reduce((a, b) => a + b, 0);
    if(count != null){
      this.noOverdueTasks = 0;
      count.forEach((element)=>{
        this.noOverdueTasks += element.ycount;
      })
    }
    this.chartTaskOptions.scales.yAxes[0].ticks.max = maxValue;
    this.chartTaskOptions.scales.yAxes[0].ticks.stepSize = maxValue/5;
    this.chartTaskData[0].data = pending;
    this.chartTaskData[1].data = upcoming;
    this.chartTaskData[2].data = overdue;
    this.chartTaskLabels = labels;
  }

  goToTaskSearch(fromDate, toDate, taskType, taskStatus, county, completionDtSw) {

    console.log('pp goToTaskSearch: fromDate, toDate, taskType, taskStatus, county, completionDtSw: ' + fromDate + ', ' + toDate+ ', ' +  taskType+ ', ' +  taskStatus+ ', ' +  county+ ', ' +  completionDtSw);
    
    if(fromDate == null && toDate != null) {
      //Overdue Link
      this.dataService.addValueToSharedDataMap('overdueTasks', true);
      console.log('Dashboard overdue flag: ' + this.dataService.getSharedDataObject().get('overdueTasks'));
    }

    this.dataService.addValueToSharedDataMap('initTaskSearchSw', 'Y');
    if(fromDate != null) {
      fromDate = this.dateUtil.formatDate(fromDate);
      fromDate = this.dateUtil.convertDateFromServer(fromDate);

    }
    if (toDate != null) {
      toDate = this.dateUtil.formatDate(toDate);
      toDate = this.dateUtil.convertDateFromServer(toDate);
    }

    if (county === undefined || county === '-1' || county === -1) {
      county = null;
    }

    this.dataService.addValueToSharedDataMap('taskDueDateFrom', fromDate);
    this.dataService.addValueToSharedDataMap('taskDueDateTo', toDate);
    this.dataService.addValueToSharedDataMap('taskType', taskType);
    this.dataService.addValueToSharedDataMap('programCd', null);
    this.dataService.addValueToSharedDataMap('taskStatus', taskStatus);
    this.dataService.addValueToSharedDataMap('searchCriteria', 'all');
    this.dataService.addValueToSharedDataMap('currentSearch', null);
    this.dataService.addValueToSharedDataMap('assignedTo', null);
    this.dataService.addValueToSharedDataMap('county', county);
    this.dataService.addValueToSharedDataMap('completionDtSw', completionDtSw);
    this.router.navigate(['/task']);
  }

  goToAnnouncements(){
    this.router.navigate(['/task/announcementsSummary']);
  }

  goToTask(){
    this.router.navigate(['/task']);
  }


  focusSummary(e) {
    this.addEventListenerToButton(e);
  }

  addEventListenerToButton(event){
    var tabKeyCode = 9;
    var spaceKeyCode = 32;
    var enterKeycode = 13;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode && event.keyCode !== spaceKeyCode && event.keyCode !== enterKeycode  ) {
      return;
    }

    if(this.dashboardSearchResponse.announcements.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    }
    else if( event.keyCode  === enterKeycode || event.keyCode == spaceKeyCode){
      this.goToAnnouncements();
    }
    else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode =  this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

}



// WEBPACK FOOTER //
// ./src/app/provider-dashboard/provider-dashboard.component.ts